import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative flex h-full" }
const _hoisted_2 = { class: "flex flex-col w-1/6 gap-y-0.5" }
const _hoisted_3 = { class: "text-2xs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Tags", -1)
const _hoisted_5 = { class: "flex w-5/6 px-2 py-1 h-4/5" }
const _hoisted_6 = { class: "flex items-center justify-start h-full border-b" }
const _hoisted_7 = { class: "w-4/6" }
const _hoisted_8 = { class: "font-mono text-xs text-gray-300" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "text-sm text-gray-300"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Reset Password ")
const _hoisted_12 = { class: "flex gap-x-2" }
const _hoisted_13 = { class: "flex flex-col w-96 gap-y-2" }
const _hoisted_14 = { class: "flex gap-x-10" }
const _hoisted_15 = { class: "flex gap-x-10" }
const _hoisted_16 = { class: "flex flex-col items-center justify-center gap-x-10" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Tag Preview", -1)

import { useTagStore } from '@/store/tags';
import { computed, inject, onMounted, Ref, ref } from 'vue';
import Tag from '@/components/User/Tag.vue';
import { useUserStore } from '@/store/users';
import { User, Tag as TagType } from '@/typings/user';
import Modal from '@/components/Modal/Modal.vue';
import TextField from '@/components/Inputs/TextField.vue';
import ColorField from '@/components/Inputs/ColorField.vue';
import { cloneDeep } from 'lodash';
import { AlertModal, PromptModal } from '@/typings/modal';
import VirtualList from '@/components/UI/VirtualList.vue';
import { apiUsers } from '@/api/users';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const creationModalVisible = ref(false);
const newTag = ref<TagType>({} as TagType);

const modalHeader = computed(() =>
  newTag.value?.Id ? 'Edit a tag' : 'Set up a tag'
);

const tagStore = useTagStore();
const userStore = useUserStore();

const users = ref<User[]>([]);

const addingTag = ref<TagType>();

const nameError = ref();

const searchTerm = ref('');
const filteredUsers = computed(() => {
  if (searchTerm.value.length) {
    return users.value.filter((u) =>
      new RegExp(searchTerm.value.toLowerCase()).exec(u.Name.toLowerCase())
    );
  }

  return users.value.slice(0, 100);
});

const alertModal = inject('alertModal') as Ref<AlertModal>;

const promptModal = inject('promptModal') as Ref<PromptModal>;

function toggleAdding(tag: TagType) {
  if (tag.Id === addingTag.value?.Id) {
    addingTag.value = undefined;
  } else {
    addingTag.value = tag;
  }
}

async function editTag(tag: TagType) {
  addingTag.value = undefined;
  newTag.value = cloneDeep(tag);
  creationModalVisible.value = true;
}

function openCreate() {
  newTag.value = {
    Text: 'New Tag',
    TextColor: '#ffffff',
    BackgroundColor: '#000000',
  };
  creationModalVisible.value = true;
}

async function saveTag() {
  if (!tagStore.tags.find((x) => x.Text === newTag.value.Text)) {
    try {
      if (newTag.value.Id) {
        await tagStore.editTag(newTag.value);
        alertModal.value.show('Tag Updated', 'A tag has been updated.');
      } else {
        await tagStore.addTag(newTag.value);
        alertModal.value.show('Tag Created', 'A new tag has been added.');
      }
      creationModalVisible.value = false;
    } catch (error) {
      console.error(error);
    }
  } else {
    nameError.value = 'Tag already exists';
  }
}

async function addTagToUser(user: User) {
  if (
    addingTag.value &&
    !user.Tags.find((t) => t.Uuid === addingTag.value?.Uuid)
  ) {
    await tagStore.addTagToUser(user, addingTag.value);
    user.Tags.push(addingTag.value);
  }
}

async function removeTagFromUser(user: User, tag: TagType) {
  if (user.Tags.find((t) => t.Uuid === tag.Uuid)) {
    await tagStore.deleteTagFromUser(user, tag);
    user.Tags = user.Tags.filter((t) => t.Uuid !== tag.Uuid);
  }
}

async function deleteTag(tag: TagType) {
  const doDelete = await promptModal.value.show(
    'Tag Deletion',
    'You are about to delete a tag. This tag will be removed from all users and will be permanently removed. Are you sure?'
  );
  if (doDelete) {
    await tagStore.deleteTag(tag);
    addingTag.value = undefined;
    alertModal.value.show('Tag Deleted', 'A tag has been removed.');
  }
}

async function getResetLink(user: User) {
  const res = await apiUsers.forgetPasswordByUuid(user.Uuid);
  await navigator.clipboard.writeText(
    `https://digital.prowrestlingscorecards.com/#/reset-password?link=${res.data.code}`
  );
  alert('Copied link to clipboard');
}

onMounted(async () => {
  tagStore.getTags();
  users.value = await userStore.getUsers();
});

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TextField, {
          modelValue: searchTerm.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
          title: "Search Users"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, " Showing " + _toDisplayString(_unref(filteredUsers).length) + " of " + _toDisplayString(users.value.length) + " users ", 1),
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tagStore).tags, (tag) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tag.Id
          }, [
            _createVNode(Tag, {
              class: _normalizeClass({ 'ml-4': addingTag.value?.Id === tag.Id }),
              tag: tag,
              onClick: ($event: any) => (toggleAdding(tag)),
              style: { cursor: 'pointer' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_fa_icon, {
                  icon: "pencil-alt",
                  class: "ml-2 hover:text-red-500",
                  onClick: _withModifiers(($event: any) => (editTag(tag)), ["prevent"])
                }, null, 8, ["onClick"]),
                _createVNode(_component_fa_icon, {
                  icon: "trash",
                  class: "ml-0.5 hover:text-red-500",
                  onClick: _withModifiers(($event: any) => (deleteTag(tag)), ["prevent"])
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["class", "tag", "onClick"])
          ]))
        }), 128)),
        _createVNode(_component_Button, {
          label: "Add Tag",
          class: "w-24",
          onClick: openCreate
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(VirtualList, {
          ref: (_value, _refs) => {
            _refs['list'] = _value
          },
          "item-size": 52,
          data: _unref(filteredUsers),
          "data-key": "Uuid"
        }, {
          default: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(item.Name) + " ", 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.Uuid), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass([
                'flex flex-wrap justify-start gap-x-0.5 gap-y-0.5 py-3 w-2/6 overflow-y-auto h-full',
                {
                  'border border-gray-400 rounded border-dashed cursor-pointer':
                    addingTag.value?.Id,
                },
              ]),
                onClick: ($event: any) => (addTagToUser(item))
              }, [
                (item.Tags.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, "No Tags"))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.Tags, (tag) => {
                      return (_openBlock(), _createBlock(Tag, {
                        key: item.Uuid + tag.Uuid,
                        tag: tag
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_fa_icon, {
                            icon: "trash",
                            class: "ml-2 hover:text-red-500",
                            onClick: _withModifiers(($event: any) => (removeTagFromUser(item, tag)), ["prevent"])
                          }, null, 8, ["onClick"])
                        ]),
                        _: 2
                      }, 1032, ["tag"]))
                    }), 128))
              ], 10, _hoisted_9),
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  class: "m-2 text-xs",
                  onClick: ($event: any) => (getResetLink(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ]),
    (newTag.value && creationModalVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          header: _unref(modalHeader),
          onClose: _cache[5] || (_cache[5] = ($event: any) => (creationModalVisible.value = false))
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "Save",
              onClick: saveTag
            }),
            _createVNode(_component_Button, {
              label: "Cancel",
              type: "secondary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (creationModalVisible.value = false))
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(TextField, {
                    modelValue: newTag.value.Text,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newTag.value.Text) = $event)),
                    title: "Tag",
                    "max-length": 10,
                    "validation-error": nameError.value
                  }, null, 8, ["modelValue", "validation-error"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(ColorField, {
                    modelValue: newTag.value.TextColor,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newTag.value.TextColor) = $event)),
                    title: "Text Color"
                  }, null, 8, ["modelValue"]),
                  _createVNode(ColorField, {
                    modelValue: newTag.value.BackgroundColor,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newTag.value.BackgroundColor) = $event)),
                    title: "Background Color"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(Tag, {
                    tag: newTag.value,
                    style: { 'font-size': '2rem !important' }
                  }, null, 8, ["tag"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})